import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@wondermaps/ui";

interface AuthLayoutProps {
  children: React.ReactNode;
  title: string;
  subtitle: string;
}

// Topographic contour pattern — large irregular shapes that tile seamlessly
const topoPatternSvg = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='800' height='800' viewBox='0 0 800 800'%3E%3Cg fill='none' stroke='white' stroke-width='1'%3E%3Cpath opacity='0.07' d='M380 50c80 10 170 60 220 140s50 180 0 260-140 120-230 110-160-70-200-150S120 220 180 140 300 40 380 50z'/%3E%3Cpath opacity='0.06' d='M390 120c55 8 120 45 155 100s35 125 0 180-100 85-160 78-110-50-140-105S215 255 255 200s80-88 135-80z'/%3E%3Cpath opacity='0.05' d='M400 200c35 5 75 30 98 65s22 80 0 115-65 55-102 50-70-32-90-67S285 290 310 260s55-65 90-60z'/%3E%3Cpath opacity='0.04' d='M405 270c20 3 42 18 55 38s12 45 0 65-37 31-58 28-40-18-51-38S340 325 355 310s30-43 50-40z'/%3E%3Cpath opacity='0.08' d='M100 500c50-30 130-20 190 15s100 90 90 155-60 110-130 120-140-10-180-60S50 630 60 570s-10-40 40-70z'/%3E%3Cpath opacity='0.06' d='M140 540c35-20 90-14 132 10s70 62 62 108-42 76-90 83-98-7-125-42S105 620 112 580s-7-22 28-40z'/%3E%3Cpath opacity='0.07' d='M550 450c60 20 110 75 120 145s-20 140-80 175-130 25-175-20-60-110-40-175S490 430 550 450z'/%3E%3Cpath opacity='0.05' d='M560 510c40 14 75 52 82 100s-14 96-55 120-90 17-120-14-42-76-28-120S520 496 560 510z'/%3E%3Cpath opacity='0.06' d='M650 100c45 5 90 40 105 90s5 110-30 145-85 40-120 25-55-50-65-100S540 140 580 110s25-15 70-10z'/%3E%3Cpath opacity='0.04' d='M660 160c28 3 56 25 66 56s3 68-19 90-53 25-74 16-34-31-40-62S580 195 605 178s20-22 55-18z'/%3E%3Cpath opacity='0.05' d='M50 150c30-15 75-5 105 20s50 60 42 100-35 65-72 70-75-8-98-40S8 235 25 200s-5-35 25-50z'/%3E%3C/g%3E%3C/svg%3E")`;

export function AuthLayout({ children, title, subtitle }: AuthLayoutProps) {
  return (
    <div className="flex min-h-screen">
      {/* Left brand panel — desktop only */}
      <div
        className="hidden lg:flex lg:w-1/2 bg-primary relative items-center justify-center overflow-hidden"
        style={{ backgroundImage: topoPatternSvg, backgroundSize: "800px 800px" }}
      >
        <a href="https://www.wondermaps.co" className="relative z-10">
          <img
            src="/wondermaps-logo-primary.png"
            alt="Wondermaps"
            className="h-12 brightness-0 invert"
          />
        </a>
      </div>

      {/* Right form panel */}
      <div className="flex w-full lg:w-1/2 items-center justify-center bg-background p-4">
        <div className="w-full max-w-sm space-y-6">
          {/* Mobile logo */}
          <div className="flex justify-center lg:hidden">
            <a href="https://www.wondermaps.co">
              <img
                src="/wondermaps-logo-small.png"
                alt="Wondermaps"
                className="h-8"
              />
            </a>
          </div>

          <Card>
            <CardHeader className="text-center">
              <CardTitle className="text-2xl">{title}</CardTitle>
              <CardDescription>{subtitle}</CardDescription>
            </CardHeader>
            <CardContent>{children}</CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}
